import { ThemeType } from 'types/publishedAssets';

export interface HeaderDisplayState {
  headerText: string;
  showLogo: boolean;
  showText: boolean;
}

/**
 * Resolves what the branded header shows for a theme. Themes published before
 * the header display config carry no headerDisplay and resolve to logoOnly,
 * so existing headers render unchanged. A textOnly theme published with blank
 * text falls back to the logo, so the header can never be empty.
 */
export function resolveHeaderDisplay(theme?: ThemeType): HeaderDisplayState {
  const headerDisplay = theme?.headerDisplay || 'logoOnly';
  const headerText = theme?.headerText?.trim() || '';
  return {
    headerText,
    showLogo: headerDisplay !== 'textOnly' || !headerText,
    showText: headerDisplay !== 'logoOnly' && !!headerText,
  };
}
